<template>
    <WpLink 
        :url="data.url" 
        :title="data.title" 
        :target="data.target" 
        v-html="title">
    </WpLink>
</template>

<script>
import WpLink from '@/components/elements/WpLink';

export default {
    name: 'acf-link',
    props: ['data'],
    computed:{
        title(){
            let title = '';
            if(this.data.title === '') {
                title = 'Les mer ...';
            }else{
                title = this.data.title
            }
            if( !!this.$slots.default ){
                title = '<span class="text">'+title+'</span>'+'<span class="slot">'+this.$slots.default[0].text+'</span>';
            }
            return title;
        },
    },
    components:{
        WpLink
    },
};
</script>
